import { useNavigate, useParams } from "react-router-dom";
import { getKeycloakRealm } from "@/components/helpers";
import { ProctoringWall } from "@/components/proctoring/ProctoringWall";

export const ProctoringWallPage = () => {
  const { termId } = useParams();
  const navigate = useNavigate();
  if (!termId) return null;
  return <ProctoringWall termId={termId} onBack={() => navigate(`/${getKeycloakRealm}/proctoring`)} />;
};
